import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const Wrap = styled(Flex)`
  flex-direction: column;
  background-image: url(${(props) => props?.image});
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 22rem;
  overflow: hidden;
  padding-top: 30px;
  padding-bottom: 16px;

  @media (min-width: ${theme.mediaqueries.small}) {
    padding-top: 40px;
    background-size: 28rem;
  }

  @media (min-width: ${theme.mediaqueries.medium}) {
    padding-bottom: 0;
  }

  @media (min-width: 1520px) {
    position: absolute;
    right: 46px;
    top: 3px;
    min-width: 420px;
    padding-top: 55px;
    background-size: 31rem;
  }
`
